import {styled} from "@mui/material";
import { getResponsiveCSS } from '@utils/cssHelpers';

export const Wrapper = styled('div')(getResponsiveCSS('marginBottom', 40, 70));
